// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './translations/en.json';
import translationNL from './translations/nl.json';
import translationDE from './translations/de.json';
import { format as formatDate, isDate } from 'date-fns';
import { enGB, nl, de } from 'date-fns/locale';
import LanguageDetector from 'i18next-browser-languagedetector';

const locales = { enGB, nl, de }; // used to look up the required locale
const DETECTION_OPTIONS = {
  order: ['localStorage', 'navigator'],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      enGB: {
        translation: translationEN,
      },
      de: {
        translation: translationDE,
      },
      nl: {
        translation: translationNL,
      },
    },
    detection: DETECTION_OPTIONS,
    fallbackLng: 'enGB',
    interpolation: {
      format: (value, format, lng) => {
        if (isDate(value) && value.toString() !== 'Invalid Date') {
          const locale = locales[lng];
          if (format === 'short') {
            return formatDate(value, 'PP', { locale });
          }
        }
        return value;
      },
    },
  });

export default i18n;
